import React from 'react';
import { motion } from 'framer-motion';

const Register = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">用戶註冊 User Registration</h1>
        <p className="page-subtitle">
          註冊新帳戶以參與投票
        </p>
      </div>
      
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="card">
            <h2>註冊功能開發中</h2>
            <p>用戶註冊功能正在開發中，敬請期待！</p>
            <p>Registration functionality is under development. Please stay tuned!</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Register;
